import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloseIcon from '@mui/icons-material/Close';

interface ScannerCameraViewProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  pageCount: number;
  maxPages: number;
  canCaptureMore: boolean;
  onCapture: () => void;
  onClose: () => void;
}

const ScannerCameraView: React.FC<ScannerCameraViewProps> = ({
  videoRef,
  pageCount,
  maxPages,
  canCaptureMore,
  onCapture,
  onClose,
}) => (
  <Box sx={{ width: '100%' }}>
    <Box
      sx={{
        width: '100%',
        aspectRatio: '3 / 4',
        maxHeight: 420,
        borderRadius: 2,
        bgcolor: '#000',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <Typography
        variant='caption'
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          bgcolor: 'rgba(0,0,0,0.6)',
          color: '#fff',
          px: 1,
          py: 0.5,
          borderRadius: 1,
        }}
      >
        {pageCount}/{maxPages} pages
      </Typography>
    </Box>

    <Stack direction='row' spacing={1.5} justifyContent='center' sx={{ mt: 2 }}>
      <Button
        variant='contained'
        startIcon={<CameraAltIcon />}
        onClick={onCapture}
        disabled={!canCaptureMore}
        sx={{
          minWidth: 140,
          '&:hover': {
            backgroundColor: '#3467FF !important',
          },
        }}
      >
        Capture
      </Button>
      <Button variant='outlined' startIcon={<CloseIcon />} onClick={onClose} sx={{ minWidth: 120 }}>
        Close
      </Button>
    </Stack>
  </Box>
);

export default ScannerCameraView;
